<template>
  <div class="yunying-rating">
    <div class="content-wrapper">
      <div class="warning">
        <i class="iconfont icon-shouji"></i>
        请在手机端查看
      </div>
      <div class="qrcode">
        <img src="@/assets/img/yunying/fensitoutiao/qrcode.png" />
      </div>
      <div class="footer">
        <i class="iconfont icon-saoyisao"></i>
        <div class="desc">
          <p>为了更好的操作体验</p>
          <p>手机扫描二维码预览</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.yunying-rating {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('~@/assets/img/yunying/fensitoutiao/bg.jpg') no-repeat center;
  background-size: cover;
  .content-wrapper {
    width: 296px;
    height: 354px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #ffffff;
    border-radius: 8px;
    padding: 35px 0 44px;
    box-sizing: border-box;
  }
  .warning {
    color: #ff8370;
    font-size: 14px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      margin-right: 10px;
    }
  }
  .qrcode {
    width: 208px;
    height: 208px;
    overflow: hidden;
    margin: 0 auto;
    padding: 14px;
    box-sizing: border-box;
    img {
      width: 100%;
      height: 100%;
      float: left;
    }
  }
  .footer {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    line-height: normal;
    i {
      margin-right: 0.25em;
      font-size: 41px;
      color: #3352fe;
    }
    p {
      margin: 0;
      font-weight: bold;
    }
  }
}
</style>
